var messages = {
  cancelText: 'Cancel',
  justOkText: 'Confirm',
  okText: 'Confrim',
  rejectText: 'Reject'
};
export default messages;